import DOMPurify from "dompurify";

const ALLOWED_TAGS = ["p", "br", "strong", "em", "u", "b", "i", "ul", "ol", "li", "a", "span", "h2", "h3"];
const ALLOWED_ATTR = ["href", "target", "rel", "class"];

const sanitize = (html) => {
  if (typeof html !== "string") return "";
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  });
  return clean;
};

// Detect whether a value already contains HTML markup (from RTE) vs. legacy plain text.
const looksLikeHtml = (s) => typeof s === "string" && /<\/?[a-z][\s\S]*>/i.test(s);

const escapeHtml = (s) => String(s)
  .replace(/&/g, "&amp;")
  .replace(/</g, "&lt;")
  .replace(/>/g, "&gt;")
  .replace(/"/g, "&quot;")
  .replace(/'/g, "&#39;");

const plainToHtml = (s) => {
  if (!s) return "";
  const lines = s.replace(/\r\n?/g, "\n").split(/\n{2,}|\n/).map((l) => l.trim()).filter(Boolean);
  if (lines.length === 0) return "";
  return lines.map((l) => `<p>${escapeHtml(l)}</p>`).join("");
};

/**
 * Safely renders rich text content produced by the RichTextEditor.
 *
 * - HTML content is DOMPurified and rendered.
 * - Legacy plain text is normalized into paragraph HTML for consistent styling.
 */
export default function RichText({ html, className = "", fallback = null, testId }) {
  if (!html || (typeof html === "string" && html.trim() === "")) return fallback;

  const source = looksLikeHtml(html) ? html : plainToHtml(html);
  const clean = sanitize(source);
  return (
    <div
      className={`vd-rich-text ${className}`}
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}

export { sanitize };
